import React, { Component } from "react";
import { Link } from "react-router-dom";
import { isSuperAdmin } from "../../utilities";
class AdminLeftNav extends Component {
  render() {
    const page = this.props.page;
    return (
      <ul className="nav nav-sidebar">
        {/* <li className={page === "dashboard" ? "active" : ""}>
          <Link to="/admin/">Dashboard</Link>
        </li> */}

        <li
          className={
            page === "modules" ||
            page === "categories" ||
            page === "workflowvideocategories" ||
            page === "workflowvideos" ||
            page === "learningcategories" ||
            page === "learningvideocategories" ||
            page === "learningvideos" ||
            page === "assignment"
              ? "active"
              : ""
          }
        >
          <Link to="/admin/modules/">Module Management</Link>
        </li>

        {/* <li className={page === "workflowvideocategories" || page === "workflowvideos" ? "active" : ""}>
          <Link to="/admin/workflowcategories/">Workflow Management</Link>
        </li> */}
        {/* <li
          className={
            page === "learningcategories" ||
            page === "learningvideocategories" ||
            page === "learningvideos" ||
            page === "assignment"
              ? "active"
              : ""
          }
        >
          <Link to="/admin/learningcategories/">Learning Management</Link>
        </li> */}

        {isSuperAdmin() && (
          <li className={page === "users" ? "active" : ""}>
            <Link to="/admin/users/">User Management</Link>
          </li>
        )}
        {/* <li className={page === "jobrolegroups" || page === "jobroles" ? "active" : ""}>
          <Link to="/admin/jobrolegroups/">Job Role Groups</Link>
        </li> */}
        {/* <li className={page === "countries" || page === "states" ? "active" : ""}>
          <Link to="/admin/countries/">Countries</Link>
        </li> */}
        {/* <li className={page === "learningvideocategories" ? "active" : ""}>
          <Link to="/admin/learningvideocategories/">Learning Video Categories</Link>
        </li>
        <li className={page === "learningvideos" ? "active" : ""}>
          <Link to="/admin/learningvideos/">Learning Videos</Link>
        </li>
        <li className={page === "assignment" ? "active" : ""}>
          <Link to="/admin/assignment/">Assignment</Link>
        </li> */}
        {/* <li className={page === "translation" ? "active" : ""}>
          <Link to="/admin/translation/">Translation</Link>
        </li> */}

        <li className={page === "integration" ? "active" : ""}>
          <Link to="/admin/integration/">LMS Integration</Link>
        </li>
        <li>
          <a rel="noopener noreferrer" target="_blank" href="https://web.microsoftstream.com/browse?q=">
            MS Stream Library
          </a>
        </li>
        {/* <li className={page === "constants" ? "active" : ""}>
          <Link to="/admin/constants/">Constants</Link>
        </li> */}
      </ul>
    );
  }
}

export default AdminLeftNav;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminLeftNav.js